import { IGlobalState } from '../../../Root/store/appReducer'
import { NotificationType } from '../../../services/api.types'

export const getUserNotificationsList = (state: IGlobalState) => state.inbox.list
export const getUserNotificationsLoading = (state: IGlobalState) => state.inbox.isLoading
// The fallback covers rehydrated persisted state from before this field existed (undefined).
export const getFeedFilter = (state: IGlobalState) => state.inbox.feedFilter || NotificationType.ANNOUNCEMENT
